import React from 'react';
import Container from '../../../containers/integration/apis/showApiContainer';

export default function () {
  return (
    <Container />
  );
}
